<style lang="scss" scoped>
    .print-icon {
        position: absolute;
        right: 10%;
        top: 5%;
        z-index: 1000;
        font-size: 1.5em;
        cursor: pointer;
        border: solid 2px #000;
        border-radius: 5px;
        color: #fff;
        background-color: #233267;
    }
    .print-icon-label {
        // font-size: 0.7em;
    }
</style>

<template>
    <div>
        <div class='print-icon p-2' @click="print()"><i class="fa fa-print pr-1" aria-hidden="true"></i><span class='print-icon-label'>Print Certificate</span></div>
        <div>
            <div v-html="template"></div>
        </div>
    </div>
</template>

<script>
    export default{
        components: {
        },
        props: {
            program: {
                type: Object,
                default: null
            },
            user: {
                type: Object,
                default: null
            },
        },
        data() {
            return {
                template: null
            }
        },
        methods: {
            print() {
                window.open(this.$basePath+'/build-the-skills/certificate/user/' + this.user.id, '_blank');
            },
            getTemplate() {
                let vm = this;
                axios.get('/build-the-skills/certificate/user/' + this.user.id)
                .then(response => {
                    vm.template = response.data;
                });
            },
        },
        computed: {
        },
        mounted() {
            this.getTemplate();
        }
    }
</script>
